import { MapTo } from '@adobe/aem-react-editable-components';
import ProductFamilyBenefits, { ProductFamilyBenefitsEditConfig } from './ProductFamilyBenefits';

export default MapTo('cob-corp-acquisition/components/creditonebank/product-family-benefits')(ProductFamilyBenefits, ProductFamilyBenefitsEditConfig);